// КЕП у браузері: файл ключа і пароль не залишають сторінку. На сервер ідуть лише підписи.
// Сертифікат беремо з .cer, які вибрав користувач, або шукаємо в АЦСК через наш проксі.
import { Buffer } from "buffer";
import { openKey, hasSigningCert, findCertsAcrossCAs, idsFromBox, signText, signBytes, signHash } from "../../lib/kep/box.js";
export { signBytes, signHash };

// Транспорт jkurwa для CMP/OCSP/TSP: query(method, url, headers, payload, cb(buf, status))
function proxyQuery(method, url, headers, payload, cb) {
  fetch(`/api/kep/proxy?url=${encodeURIComponent(url)}`, {
    method: "POST",
    credentials: "same-origin",
    // Тип запиту до АЦСК (CMP/OCSP/TSP) передаємо окремим заголовком: наше тіло — завжди octet-stream
    headers: { "Content-Type": "application/octet-stream", "X-Upstream-Content-Type": headers?.["Content-Type"] || "application/octet-stream" },
    body: payload ? new Uint8Array(payload) : undefined,
  })
    .then(async (r) => {
      const buf = Buffer.from(await r.arrayBuffer());
      cb(buf, r.ok ? Number(r.headers.get("x-upstream-status")) || 200 : r.status);
    })
    .catch(() => cb(Buffer.alloc(0), 599));
}

const read = (file) => file.arrayBuffer().then((b) => Buffer.from(b));

// keyFile — File ключа; certFiles — File[] сертифікатів (необов'язково)
export async function loadKey({ keyFile, password, certFiles = [], log = () => {} }) {
  let box;
  try {
    box = openKey({ keyBuffer: await read(keyFile), password, certBuffers: await Promise.all(certFiles.map(read)), query: proxyQuery });
  } catch (e) {
    throw new Error(`Не вдалося відкрити ключ — перевірте пароль (${e.message})`);
  }
  if (!box.keys.some((k) => k.priv)) throw new Error("Не вдалося відкрити ключ — перевірте пароль");
  if (!hasSigningCert(box)) {
    await findCertsAcrossCAs(box, undefined, log);
    if (!hasSigningCert(box)) throw new Error("Сертифікат до ключа не знайдено — додайте файли .cer");
  }
  return { box, ...idsFromBox(box) };
}

// Два підписи одним ключем: ЄДРПОУ для ДПС і одноразовий виклик сервера
export async function signLogin(box, edrpou, challengeText) {
  return {
    authSignature: await signText(box, edrpou),
    challengeSignature: await signText(box, challengeText),
  };
}
